import withHasPermission from '../../hoc/withHasPermission';
import { Permission } from '../../permissions/permission';
import { AgentInstallationView } from './AgentInstallationView';

export const AgentInstallation = withHasPermission(() => {
    return <AgentInstallationView />;
}, Permission.Root_InstallAgent);
